import { render, staticRenderFns } from "./wordDetailPromotion.vue?vue&type=template&id=0d6847fc&scoped=true"
import script from "./wordDetailPromotion.vue?vue&type=script&lang=js"
export * from "./wordDetailPromotion.vue?vue&type=script&lang=js"
import style0 from "./wordDetailPromotion.vue?vue&type=style&index=0&id=0d6847fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6847fc",
  null
  
)

export default component.exports